import no_intro1 from 'assets/sounds/no/rapidNaming/rapidNaming-intro1-old.mp3';
import no_intro2 from 'assets/sounds/no/rapidNaming/rapidNaming-intro2-old.mp3';
import no_intro3 from 'assets/sounds/no/rapidNaming/rapidNaming-intro3-old.mp3';
import no_intro4 from 'assets/sounds/no/rapidNaming/rapidNaming-intro4-old.mp3';
import no_intro5 from 'assets/sounds/no/rapidNaming/rapidNaming-intro5.mp3';

import nn_intro1 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro1-old.mp3';
import nn_intro2 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro2-old.mp3';
import nn_intro3 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro3-old.mp3';
import nn_intro4 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro4-old.mp3';
import nn_intro5 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro5.mp3';

import no_norming_intro1 from 'assets/sounds/no/rapidNaming/rapidNaming-norming-intro1.mp3';
import no_norming_intro2 from 'assets/sounds/no/rapidNaming/rapidNaming-intro2.mp3';
import no_norming_intro3 from 'assets/sounds/no/rapidNaming/rapidNaming-intro3.mp3';
import no_norming_intro4 from 'assets/sounds/no/rapidNaming/rapidNaming-intro4.mp3';
import no_norming_intro5 from 'assets/sounds/no/rapidNaming/Hurtigbenevning-instruction-nr-2.mp3';

import nn_norming_intro1 from 'assets/sounds/nn/rapidNaming/rapidNaming-norming-intro1.mp3';
import nn_norming_intro2 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro2.mp3';
import nn_norming_intro3 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro3.mp3';
import nn_norming_intro4 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro4.mp3';
import nn_norming_intro5 from 'assets/sounds/nn/rapidNaming/nn-Hurtigbenevning-instruction-n.mp3';

import gulteple from '../../assets/images/norming/rapidNaming/eple_gul-min.png';
import gronnkake from '../../assets/images/norming/rapidNaming/kake_green-min.png';
import rodstjerne from '../../assets/images/norming/rapidNaming/stjerne_red-min.png';
import brunteple from '../../assets/images/norming/rapidNaming/eple_brown-min.png';
import gulkake from '../../assets/images/norming/rapidNaming/kake_yellow-min.png';
import blastjerne from '../../assets/images/norming/rapidNaming/stjerne_blue-min.png';
import gronnsykkel from '../../assets/images/norming/rapidNaming/sykkel_gronn-min.png';
import brunkake from '../../assets/images/norming/rapidNaming/kake_brown-min.png';
import gulsykkel from '../../assets/images/norming/rapidNaming/sykkel_gul-min.png';
import gronnteple from '../../assets/images/norming/rapidNaming/eple_gronn-min.png';
import rodkake from '../../assets/images/norming/rapidNaming/kake_red-min.png';
import brunsykkel from '../../assets/images/norming/rapidNaming/sykkel_brown-min.png';
import blaeeple from '../../assets/images/norming/rapidNaming/eple_bla-min.png';
import rodmane from '../../assets/images/norming/rapidNaming/moon_red-min.png';
import blasykkel from '../../assets/images/norming/rapidNaming/sykkel-blue-min.png';
import gulstjerne from '../../assets/images/norming/rapidNaming/stjerne_gul-min.png';
import blamane from '../../assets/images/norming/rapidNaming/moon_blue-min.png';
import rodsykkel from '../../assets/images/norming/rapidNaming/sykkel_red-min.png';
import gronnstjerne from '../../assets/images/norming/rapidNaming/star_green-min.png';
import gulmane from '../../assets/images/norming/rapidNaming/moon_yellow-min.png';
import rodteple from '../../assets/images/norming/rapidNaming/eple_red-min.png';
import blakake from '../../assets/images/norming/rapidNaming/kake_blue-min.png';
import gronnmane from '../../assets/images/norming/rapidNaming/moon_green-min.png';

import brunmane from '../../assets/images/norming/rapidNaming/moon_brown-min.png';
import brunstjerne from '../../assets/images/norming/rapidNaming/stjerne_brown-min.png';

export const no = {
	intro1: no_intro1,
	intro2: no_intro2,
	intro3: no_intro3,
	intro4: no_intro4,
	intro5: no_intro5,
};

export const nn = {
	intro1: nn_intro1,
	intro2: nn_intro2,
	intro3: nn_intro3,
	intro4: nn_intro4,
	intro5: nn_intro5,
};

export const noNorming = {
	intro1: no_norming_intro1,
	intro2: no_norming_intro2,
	intro3: no_norming_intro3,
	intro4: no_norming_intro4,
	intro5: no_norming_intro5,
};

export const nnNorming = {
	intro1: nn_norming_intro1,
	intro2: nn_norming_intro2,
	intro3: nn_norming_intro3,
	intro4: nn_norming_intro4,
	intro5: nn_norming_intro5,
};

export const normingGrade234Images = {
	yellowapple: gulteple,
	greencake: gronnkake,
	bluebike: blasykkel,
	redstar: rodstjerne,
	brownapple: brunteple,
	yellowmoon: gulmane,
	greenbike: gronnsykkel,
	bluestar: blastjerne,
	browncake: brunkake,
	yellowbike: gulsykkel,
	greenapple: gronnteple,
	redmoon: rodmane,
	brownbike: brunsykkel,
	blueapple: blaeeple,
	redcake: rodkake,
	yellowstar: gulstjerne,
	bluemoon: blamane,
	brownstar: brunstjerne,
	redbike: rodsykkel,
	greenmoon: gronnmane,
	yellowstar2: gulstjerne,
	redapple: rodteple,
	bluecake: blakake,
	brownmoon: brunmane,
	greenstar: gronnstjerne,
};

export const normingGrade567YouthAdultImages = {
	bluebike: blasykkel,
	redapple: rodteple,
	greenmoon: gronnmane,
	browncake: brunkake,
	yellowstar: gulstjerne,
	blueapple: blaeeple,
	greenbike: gronnsykkel,
	redstar: rodstjerne,
	brownmoon: brunmane,
	yellowcake: gulkake,
	greenapple: gronnteple,
	bluestar: blastjerne,
	redmoon: rodmane,
	brownbike: brunsykkel,
	yellowapple: gulteple,
	greencake: gronnkake,
	bluemoon: blamane,
	redbike: rodsykkel,
	brownapple: brunteple,
	yellowmoon: gulmane,
	bluecake: blakake,
	greenstar: gronnstjerne,
	redcake: rodkake,
	yellowbike: gulsykkel,
	brownstar: brunstjerne,
	bluemoon2: blamane,
	greenapple2: gronnteple,
	yellowstar2: gulstjerne,
	redbike2: rodsykkel,
	browncake2: brunkake,
	greenmoon2: gronnmane,
	bluebike2: blasykkel,
	yellowapple2: gulteple,
	redstar2: rodstjerne,
	brownmoon2: brunmane,
	bluecake2: blakake,
	greenbike2: gronnsykkel,
	yellowmoon2: gulmane,
	redapple2: rodteple,
	brownstar2: brunstjerne,
	greencake2: gronnkake,
	bluestar2: blastjerne,
	yellowbike2: gulsykkel,
	redmoon2: rodmane,
	blueapple2: blaeeple,
	greenstar2: gronnstjerne,
	yellowcake2: gulkake,
	brownapple2: brunteple,
	redcake2: rodkake,
	brownbike2: brunsykkel,
};
